var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 88,
    viewBox: "0 0 65 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4566 52.4333L77.99 70.7667C77.44 76.3767 77 80.6667 67.0633 80.6667H20.9366C11 80.6667 10.56 76.3767 10.01 70.7667L8.54329 52.4333C8.24996 49.39 9.20329 46.5667 10.9266 44.4033C10.9633 44.3667 10.9633 44.3667 11 44.33C13.0166 41.8733 16.06 40.3333 19.47 40.3333H68.53C71.94 40.3333 74.9466 41.8733 76.9266 44.2567C76.9633 44.2933 77 44.33 77 44.3667C78.7966 46.53 79.7866 49.3533 79.4566 52.4333Z",
    stroke: "url(#paint0_linear_1671_24295)",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 41.91V23.0267C12.8335 10.56 15.9502 7.44333 28.4168 7.44333H33.0735C37.7302 7.44333 38.7935 8.83666 40.5535 11.1833L45.2102 17.4167C46.3835 18.9567 47.0802 19.91 50.1968 19.91H59.5468C72.0135 19.91 75.1302 23.0267 75.1302 35.4933V42.0567",
    stroke: "url(#paint1_linear_1671_24295)",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5767 62.3333H53.4233",
    stroke: "url(#paint2_linear_1671_24295)",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1671_24295",
    x1: 8.97344,
    y1: 40.3333,
    x2: 8.97344,
    y2: 80.1184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455CC7",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455CC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1671_24295",
    x1: 13.2569,
    y1: 7.44333,
    x2: 13.2569,
    y2: 41.5862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455CC7",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455CC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1671_24295",
    x1: 34.7047,
    y1: 62.3333,
    x2: 34.7047,
    y2: 63.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455CC7",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455CC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/FolderOpen.142b03a7.svg";
export { ForwardRef as ReactComponent };